<template>
  <div>
    <div v-if="label" class="mb-2">{{ label }}</div>
    <v-select
      :filter="fuseSearch"
      :name="name"
      :value="selectedValueCustom"
      :placeholder="placeholder"
      @input="input"
      :label="option_label"
      :options="options"
      :taggable="taggable"
      :multiple="multiple"
      :clearable="clearable"
      :disabled="disabled"
      :clearSearchOnBlur="clearSearchOnBlur"
      :noDrop="noDrop"
      :selectOnTab="selectOnTab"
      :map-keydown="mapKeydown"
      :class="{ 'is-danger': error }"
      @search="handleFetchOption"
      :selectable="
        () => (multiple && limit ? selectedValueCustom.length < limit : true)
      "
      :threshold="threshold"
    >
      <template v-slot:option="option" v-if="showTooltip">
        <span :title="option.title">{{ option.label }}</span>
      </template>
      <template #no-options="{ searching }">
        <template v-if="searching">
          <span style="color: red" v-if="noOptionsWhileSearch">{{
            noOptionsWhileSearch
          }}</span>
          <span v-else>Sorry, no matching options.</span>
        </template>
      </template>
    </v-select>
    <small class="has-error" v-if="error">{{ error }}</small>
  </div>
</template>

<script>
import { isObject, isEmptyObjectCheck } from "@/helpers/helper";
import Fuse from "fuse.js";
export default {
  name: "Select",
  props: {
    name: {
      type: String,
      default: "SelectBox",
    },
    placeholder: {
      type: String,
      default: "Start typing",
    },
    value: {
      type: [Object, String, Number, Array],
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: undefined,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fetchOptions: {
      type: Function,
      default: () => {},
    },
    option_label: {
      type: String,
      default: undefined,
    },
    limit: {
      type: Number,
      default: null,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    noOptionsWhileSearch: {
      type: String,
      default: "",
    },
    clearSearchOnBlur: {
      type: Function,
      default: () => {
        return true;
      },
    },
    noDrop: {
      type: Boolean,
      default: false,
    },
    mapKeydown: {
      type: Function,
      default: (map, vm) => map,
    },
    selectOnTab: {
      type: Boolean,
      default: false,
    },
    autoPopulate: {
      type: Boolean,
      default: false,
    },
    threshold: {
      type: Number,
      default: 0.4,
    }
  },
  watch: {
    options(newOptions, oldOptions) {
      if (newOptions.length === 1 && this.autoPopulate) {
        this.$emit("change", this.name, newOptions[0]);
        this.$emit("input", this.name, newOptions[0]);
      } else if (
        this.options &&
        this.options.find &&
        this.value &&
        oldOptions.length > 0 &&
        (Array.isArray(this.value) ? this.value.length : true)
      ) {
        const { code, label } = this.value;
        const result = this.options.find(
          (o) => o.code === code && o.label === label
        );
        if (!result && !this.multiple) {
          this.$emit("change", this.name, null);
          this.$emit("input", this.name, null);
        }
      }
    },
  },
  computed: {
    selectedValueCustom() {
      if (isObject(this.value) && isEmptyObjectCheck(this.value)) {
        return [];
      }
      return this.value || [];
    },
  },
  methods: {
    input(value) {
      this.$emit("change", this.name, value);
      this.$emit("input", this.name, value);
    },
    handleFetchOption(search, loading) {
      this.fetchOptions(search, loading, this.name);
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["label"],
        shouldSort: true,
        threshold: this.threshold
      });
      return search.length ? fuse.search(search).map(({ item }) => item) : [];
    },
  },
  mounted() {
    if (this.options.length === 1 && this.autoPopulate) {
      this.$emit("change", this.name, this.options[0]);
      this.$emit("input", this.name, this.options[0]);
    }
  },
};
</script>
<style lang="scss">
.has-error {
  color: $red;
}
.is-danger {
  .vs__dropdown-toggle {
    border-color: $red;
    box-shadow: none;
    outline: none;
  }
}
.vs__search {
  color: #b8b8b8 !important;
  padding: 0 2px !important;
}
</style>
